import { useCallback } from 'react';
import { useUpdateLitter } from './useUpdateLitter';

export const useDeleteLitter = () => {
  const { updateLitter, updateLitterLoading, updateLitterError } = useUpdateLitter();

  const deleteLitter = useCallback(
    async (litterId?: number) => {
      if (!litterId) return;
      return updateLitter({
        variables: {
          litterId,
          data: {
            archived: { set: true },
          },
        },
      });
    },
    [updateLitter],
  );

  return {
    deleteLitterLoading: updateLitterLoading,
    deleteLitterError: updateLitterError,
    deleteLitter,
  };
};
